module.exports = __webpack_public_path__ + "img/B01_HQ06.203f84b3.jpg";